import { Typography, TextField, FormLabel, FormControl, Box, Button, 
        IconButton, Menu,  Table,  TableBody,  
        TableCell,  TableHead,  TableRow, } from '@mui/material';
import { useEffect, useState } from 'react';
import axios from '../../api/axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { InputLabel, Select, MenuItem } from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { Outlet, useLocation } from "react-router-dom";

const GET_RESTORE = "superadmin/restoredata";
const GET_SUPERADMINSETTINGS = "/superAdminSettings";
const TOTAL_CONTAINERS = 28;

export const Restore = () => {
  const auth = useAuth();
  const navigate = useNavigate();  
  const location = useLocation();
  
  return (
    <Box display="flex" height="100%">  
        <Box width="200px" minHeight="100vh" bgcolor="#ffffff" p={2}>
            <Button fullWidth variant="text" onClick={() => navigate("/superadmin/restoredata")} sx={{ justifyContent: "flex-start", 
                    fontWeight: location.pathname === "/superadmin/restoredata" ? "bold" : "normal",
                    bgcolor: location.pathname === "/superadmin/restoredata" ? "#e8eef6" : "transparent", color: "black", 
                    textTransform: "none", "&:hover": { bgcolor: location.pathname === "/superadmin/restoredata" ? "#d7e3f3" : "#f0f0f0" }}} >
                Restore Plan Data
            </Button>

            <Button fullWidth variant="text" onClick={() => navigate("/superadmin/globalsettings")} sx={{ justifyContent: "flex-start", color: "black", 
                    fontWeight: location.pathname === "/superadmin/globalsettings" ? "bold" : "normal",
                    bgcolor: location.pathname === "/superadmin/globalsettings" ? "#e8eef6" : "transparent", 
                    textTransform: "none", "&:hover": { bgcolor: location.pathname === "/superadmin/globalsettings" ? "#d7e3f3" : "#f0f0f0" }}}>
                Global Settings
            </Button>
        </Box>

        <Box flexGrow={1} pl={3}>
          <Outlet />
        </Box>
      </Box>    
    )
}

export const RestoreData = () => {  
  const [backups, setBackups] = useState([]); 
  const [selectedBackup, setSelectedBackup] = useState("");
  const [orgsList, setOrgsList] = useState([]); 
  const [selectedOrg, setSelectedOrg] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedBackupDate, setSelectedBackupDate] = useState("");
  
  const [dialogText, setDialogText] = useState("");
  const [progressDialogOpen, setProgressDialogOpen] = useState(false);
  
  const [anchorEl, setAnchorEl] = useState(null);
  
  const token = localStorage.getItem('token');
  const orgID = localStorage.getItem('orgId');

  useEffect(() => {
    const requestData = {
      token: token,
      getSuperadminSettings: true
    };
  
    axios.post(GET_SUPERADMINSETTINGS, requestData)
      .then((response) => {
        if (response?.status === 200) {
          const lastDate = new Date(response.data.message.superadminsettings.lastBackupDateTime);
          var lastNum = response.data.message.superadminsettings.lastContainerNumber;

          var history = response.data.message.superadminsettings.containerBackupHistory;

          const generatedBackups = Object.entries(history)
                                  .flatMap(([containerNumber, dates]) =>
                                    dates.map(d => ({
                                      containerNumber: Number(containerNumber),
                                      date: d
                                    }))
                                  );

          setBackups(generatedBackups);

        } else if (response?.status === 400) {
          console.log("Bad Request:", response.data);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  }, [token]);
  
   const handleMenuOpen = (event, member, type) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(member);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleRestoreProcess = (orgID) => {
    setAnchorEl(null);
    setDialogOpen(false);

    setProgressDialogOpen(true);
    setDialogText("Removing data...");

    //remove data
    const requestRemoveData = {
          token: token,
          removeDateBeforeRestore: true,
          orgId: orgID
        };

    axios.post(GET_RESTORE, requestRemoveData).then((response) => {
        if (response?.status === 200) {
          console.log("Data is removed from DB.");
          setDialogText("Copying data...");
        } else if (response?.status === 400) {
          console.log("Bad Request:", response.data);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });        
    
    //restore 
    const requestRestoreData = {
          token: token,
          restoreDataFromBackup: true,
          orgId: orgID
        };

    axios.post(GET_RESTORE, requestRestoreData).then((response) => {
        if (response?.status === 200) {
          console.log("Data is restored.");
          
          setDialogText(<span style={{ color: "green" }}>✓ Done</span>);
          setTimeout(() => {            
            setProgressDialogOpen(false);
          }, 3000);

        } else if (response?.status === 400) {
          console.log("Bad Request:", response.data);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const handleBackupSelect = (clickedContainerNumber) => {
    console.log("Selected backup:", clickedContainerNumber);    
    setSelectedBackup(clickedContainerNumber);

    const requestData = {
          token: token,
          getContainerOrgData: true,
          containerNumber: clickedContainerNumber,
          ordId: orgID
        };

    axios.post(GET_RESTORE, requestData).then((response) => {
        if (response?.status === 200) {
          const list = [];

          for (let i = 0; i< response.data.message.listOfOrgs.length; i++)
          {
            list.push({
                orgName: response.data.message.listOfOrgs[i].organizationName,
                orgId: response.data.message.listOfOrgs[i].id,
              });
          }
          list.sort((a, b) => a.orgName.localeCompare(b.orgName));
          
          setOrgsList(list);
          setSelectedOrg(true);

        } else if (response?.status === 400) {
          console.log("Bad Request:", response.data);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  return (
    <Box display="flex" height="100%">  
      <Box flexGrow={1} pl={3} sx={{ ml: "48px"}}>
        <Typography variant="h2" gutterBottom sx={{ mb: '24px', mt: '24px', marginLeft:'-24px' }}>
          Restore Plan Data
        </Typography>

        <Typography variant="h6" fontWeight="medium" letterSpacing="0.15px" lineHeight="160%" gutterBottom sx={{ mt: '24px', mb: '0px' }}>
          Available Backups
        </Typography>

        <Typography variant="body1" color="text.secondary" gutterBottom  sx={{ mt: '-5px' }}>
          Select a backup to view organizations with an available restore point
        </Typography>

        <FormControl variant="standard" sx={{ width: 250, mt: '24px', mb: '24px' }}>
          <InputLabel id="simple-select-label">Select a backup</InputLabel>
          <Select labelId="backup-select-label" value={selectedBackup}  displayEmpty
                  onChange={(e) => 
                  {
                    setOrgsList([]);
                    setSelectedOrg(false);
                    handleBackupSelect(e.target.value); 
                    const backup = backups.find(b => b.containerNumber === e.target.value); 
                    setSelectedBackupDate(new Date(backup?.date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', timeZone: 'UTC' }));
                  }}  
          >                  
            {backups.map((b) => (
              <MenuItem key={b.containerNumber} value={b.containerNumber} /* disabled={!b.hasData}*/>
                {new Date(b.date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', timeZone: 'UTC' })}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {selectedOrg && (
          <Table sx={{ mt: '24px' }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold' }}>Organization</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Org ID</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>

            <TableBody>
              {orgsList.map((org, index) => (
                <TableRow key={`active-${index}`} hover>
                  <TableCell>{org.orgName}</TableCell>              
                  <TableCell>{org.orgId}</TableCell>
                  <TableCell align="left" sx={{ width: "60px" }}>                  
                      <IconButton onClick={(e) => handleMenuOpen(e, org, 'active')}>
                        <MoreVertIcon />
                      </IconButton>                  
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>

            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} 
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}>
              <MenuItem key="restore" onClick={() => { setDialogOpen(true);}} sx={{ color: '#D32F2F' }}>
                Restore
              </MenuItem>
            </Menu>
          </Table>
        )}
      </Box>

      <Dialog open={dialogOpen} /*onClose={() => setDialogOpen(false)} */ PaperProps={{ sx: { width: 600,  height: 260 } }} >
        <DialogTitle><strong>Restore from backup?</strong></DialogTitle>
        <DialogContent sx={{ fontFamily: "Manrope, sans-serif",fontSize: "16px" }}>
          All plan data in <strong>{selectedRow?.orgName}</strong> will be overwritten with plan data from the backup dated <strong>{selectedBackupDate}</strong>
          <br /> <br />
          <strong>THIS ACTION CANNOT BE UNDONE</strong> 
        </DialogContent>

        <DialogActions>
          <Button variant="contained" onClick={() => handleRestoreProcess(selectedRow?.orgId)} color="error" sx={{ minWidth: "150px", width: "250px", height: "36px", mb: "4px", ml: "16px", 
                                                                                            fontSize: "16px", whiteSpace: "nowrap", marginRight: "260px", fontWeight: 100,
                                                                                            overflow: "hidden", textOverflow: "ellipsis", fontFamily: "Manrope, sans-serif" }}>
            OVERWRITE & RESTORE
          </Button>
          <Button onClick={() => { setDialogOpen(false); handleMenuClose(); }} color="primary" autoFocus sx={{ mr: "24px", fontSize: "14px", mb: "4px"}}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={progressDialogOpen} PaperProps={{ sx: { width: 600,  height: 260 } }} >
        <DialogContent sx={{ fontFamily: "Manrope, sans-serif", display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center",  height: "100%", fontSize: "28px" }}>
          <strong>{dialogText}</strong>
        </DialogContent>
      </Dialog> 
    </Box>    
  )
}